<template>
  <div style="margin-top:24px;">
    <CommonExpansionPanel>
      <template v-slot:title-panel>Documentos</template>
      <v-expansion-panel-content>
        <TablaDocumentosAlianza
          v-if="switch_data == 1"
          :alianzaData="alianzaData"
        >
        </TablaDocumentosAlianza>
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>
<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import TablaDocumentosAlianza from "./TablaDocumentosAlianza.vue";

export default {
  components: {
    CommonExpansionPanel,
    TablaDocumentosAlianza,
  },
  props: {
    alianzaData: Object,
  },
  data() {
    return {
      switch_data: 1,
    };
  },
};
</script>
